import {HttpClient, HttpParams} from '@angular/common/http';
import {take, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

export interface User {
  email: string;
  username: string;
  profile: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  userRole: string = '';

  constructor(
    private http: HttpClient
  ) {
  }

  logout() {
    localStorage.clear()
    sessionStorage.clear();
  }

  get username() {
    if (localStorage.getItem('currentLogin') == null) {
      return 'kn';
    } else {
      return (localStorage.getItem('currentLogin') as string).split('@')[0];
    }
  }

  set currentLogin(currentLogin) {
    localStorage.setItem('currentLogin', currentLogin as string);
  }

  set name(name: string) {
    localStorage.setItem('name', name);
  }

  get currentLogin() {
    if (localStorage.getItem('currentLogin') == null) {
      return 'kn';
    } else {
      return (localStorage.getItem('currentLogin') as string).substring(0, 1);
    }
  }

  get bearerToken() {
    return localStorage.getItem('bearerToken');
  }

  set bearerToken(bearerToken) {
    localStorage.setItem('bearerToken', bearerToken as string);
  }

  get typeLogin() {
    return localStorage.getItem('typeLogin');
  }

  get isExpired(): boolean {
    const expiry = JSON.parse(atob(this.bearerToken!.split('.')[1])).exp;
    return (Math.floor((new Date).getTime() / 1000 )) >= expiry;
  }

  get isAuthenticated(): boolean {
    return !!this.bearerToken && !this.isExpired;
  }

  get isRequester() {
    return this.typeLogin === 'requester';
  }

  get isApproverOrders() {
    return this.typeLogin === 'approverOrders';
  }

  get isApproverBudgets() {
    return this.typeLogin === 'approverBudgets';
  }

  get isAdmin() {
    return this.typeLogin === 'admin';
  }

  isFromLoggedUser(username: string) {
    return this.username === username;
  }

  email: any;

  verifyExists(username: string) {
    return this.http.get<any>(`${environment.apiUrl}/api/users/username`, {
      params: {username}
    }).pipe(
      tap((value) => {
        this.userRole = value.profile;
        switch (value.profile) {
          case 'Administrador':
            localStorage.setItem('typeLogin', 'admin');
            break;
          case 'Aprovador de Pedidos':
            localStorage.setItem('typeLogin', 'approverOrders');
            break;
          case 'Aprovador de Orçamentos':
            localStorage.setItem('typeLogin', 'approverBudgets');
            break;
          case 'Solicitante':
            localStorage.setItem('typeLogin', 'requester');
            break;
        }
      }),
      take(1)
    );
  }

  authenticate(loginInfo: { login: string; password: string }) {
    return this.http
      .post<any>(`${environment.authUrl}/authenticate/login`, loginInfo)
      .pipe(
        take(1),
        tap((response) => {
          this.name = response.userDetail.firstName + " " + response.userDetail.surname
          this.bearerToken = response.token;
          this.currentLogin = loginInfo.login;
        })
      );
  }

  set isSSO(isSSO: boolean){
    localStorage.setItem('isSSO', isSSO? 'true':'false');
  }

  get isSSO(){
    return localStorage.getItem('isSSO') === 'true';
  }

  getSelfInfo(){
    return this.http.get<any>(`${environment.apiUrl}/api/users/self`)
  }

  getSSOToken(code: any) {
    const params = new HttpParams()
      .append('grant_type', 'authorization_code')
      .append('client_id', environment.clientId)
      .append('client_secret', environment.clientSecret)
      .append('redirect_uri', environment.redirectUri)
      .append('code', code as string)
      .append('code_verifier', 'code');

    return this.http.post<{ access_token: string, refresh_token: string, sub: string }>(`${environment.ssoUrl}/authorization/oauth2/token`, params)
      .pipe(
        take(1),
        tap(response => {
          this.isSSO = true;
        })
      );
  }
}
